import { render, staticRenderFns } from "./web-view.vue?vue&type=template&id=59b2888c&"
import script from "./web-view.vue?vue&type=script&lang=js&"
export * from "./web-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports